export default __webpack_public_path__ + "static/media/166.717c4b84.svg";